<template>
  <div class="container row-fluild" :class="{ hidden: !show }">
    <div>
      <a href="javascript:void(0);" @click="selectEven" class="selOpt">{{ t('days_of_month').even_days }}</a>
      <a href="javascript:void(0);" @click="selectOdd" class="selOpt">{{ t('days_of_month').odd_days }}</a>
      <a href="javascript:void(0);" @click="selectAll" class="selOpt">{{ t('days_of_month').all_days }}</a>
      <a href="javascript:void(0);" @click="selectNone" class="selOpt">{{ t('days_of_month').no_day }}</a>
    </div>
    <p class="fbreaker" />

    <template v-for="day in days">
      <div :key="day" class="mday rounded">
        <input v-model="selectedDays" type="checkbox" :value="day" :name="`${model}[days][]`" :id="`d_${day}`" />
        <label :for="`d_${day}`">{{ day }}</label>
      </div>
      <p :key="`p${day}`" class="breaker" v-if="day > 1" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'days-of-month',
  data() {
    return {
      days: [...Array(32).keys()].slice(1),
      selectedDays: [],
      show: true,
      // days: [...Array(31).keys()].map((curr, index, arr) => ({ id: (curr + 1), selected: false })),
    };
  },
  props: ['model', 'selected'],
  created() {
    this.selectedDays = this.selected.slice(0);
  },
  mounted() {
    eventBus.$on('calendarOccurrenceSelectByChanged', (selection) => {
      this.show = selection.type == 'monthly';
      if (!this.show) this.selectNone();
    });
  },
  methods: {
    selectAll() {
      this.selectedDays = [...Array(32).keys()].slice(1);
    },
    selectEven() {
      this.selectedDays = [...Array(32).keys()].slice(1).filter((n) => n % 2 == 0);
    },
    selectNone() {
      this.selectedDays = [];
    },
    selectOdd() {
      this.selectedDays = [...Array(32).keys()].slice(1).filter((n) => n > 0 && n % 2 == 1);
    },
    t: (i18nKey) => window.i18nJS[i18nKey],
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-flow: row wrap;
  justify-content: normal;
  width: inherit;
  .fbreaker,
  .breaker:nth-of-type(7n) {
    display: block;
    width: 100%;
    height: 0;
  }
  .selOpt {
    padding: 5px 10px;
    border-right: 1px solid #aaa;
    &:last-of-type {
      border: none;
    }
  }
  .rounded {
    counter-increment: day;
    display: inline-block;
    border: 1px solid #999;
    margin: 5px;
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 50px;
    position: relative;
    label {
      color: #aaa;
      cursor: pointer;
      position: absolute;
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50px;
      text-align: center;
      top: 0;
      .breaker {
        display: none;
      }
      &:after {
        filter: alpha(opacity = 0);
        opacity: 0;
        content: counter(day);
        color: #ef7b12;
        border-color: #ef7b12;
        position: absolute;
        left: 0;
        width: 32px;
        height: 32px;
        border-radius: 50px;
      }
      &:hover::after {
        opacity: 0.3;
      }
    }
    input[type='checkbox'] {
      visibility: hidden;
    }
    input[type='checkbox']:checked + label:after {
      color: #ff8215;
      border: 2px solid #ff8215;
      font-weight: 600;
      opacity: 1;
      top: -2px;
      left: -2px;
    }
  }
}
</style>
